module.exports = __webpack_public_path__ + "main/images/signup/pocket-logo-illus.0b427b060ff7fa4900b7aa4df21c368e.svg";